export default __webpack_public_path__ + "static/t4-c3ede3a88df2c18b4fde9b2e61f10242.jpg";